<router-outlet>
  @if (omniChat$ | async) {
    <service-now-chat />
  }
</router-outlet>
